"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateHatchState = exports.MINIME_TOKEN = exports.ERC20_TOKEN = exports.AGENT_APP = exports.HATCH_ORACLE_APP = exports.HATCH_APP = exports.IMPACT_HOURS_APP = void 0;
const ethers_1 = require("ethers");
const hatch_states_1 = require("../hatch-states");
exports.IMPACT_HOURS_APP = 'impact-hours-beta';
exports.HATCH_APP = 'marketplace-hatch';
exports.HATCH_ORACLE_APP = 'hatch-oracle';
exports.AGENT_APP = 'agent';
exports.ERC20_TOKEN = 'erc20';
exports.MINIME_TOKEN = 'minime';
function calculateHatchState(hatch, subgraphState) {
    const now = Date.now() / 1000;
    const totalRaised = ethers_1.BigNumber.from(hatch.totalRaised);
    const maxGoal = ethers_1.BigNumber.from(hatch.maxGoal);
    const minGoal = ethers_1.BigNumber.from(hatch.minGoal);
    const openDate = Number(hatch.openDate);
    const period = Number(hatch.period);
    if (openDate === 0 || openDate > now) {
        return hatch_states_1.STATE_PENDING;
    }
    if (totalRaised.gte(maxGoal)) {
        if (subgraphState === hatch_states_1.STATE_CLOSED) {
            return hatch_states_1.STATE_CLOSED;
        }
        else {
            return hatch_states_1.STATE_GOAL_REACHED;
        }
    }
    if (now - openDate < period) {
        return hatch_states_1.STATE_FUNDING;
    }
    else if (totalRaised.gte(minGoal)) {
        if (subgraphState === hatch_states_1.STATE_CLOSED) {
            return hatch_states_1.STATE_CLOSED;
        }
        else {
            return hatch_states_1.STATE_GOAL_REACHED;
        }
    }
    else {
        return hatch_states_1.STATE_REFUNDING;
    }
}
exports.calculateHatchState = calculateHatchState;
//# sourceMappingURL=app-utils.js.map